import { NASStatus, usenasServicesRefundMutation } from '@websky/graphql';
import { useMemo } from 'react';

export const useAirportServicesRefund = (orderId: string) => {
	const [request, { data, loading }] = usenasServicesRefundMutation();

	const refundedServiceIds = useMemo(() => {
		return data?.NASServicesRefund?.filter(service => service.status === NASStatus.Refunded).map(
			service => service.serviceId
		);
	}, [data]);

	const refundedWithError = useMemo(() => {
		return data?.NASServicesRefund?.filter(service => !!service.error);
	}, [data]);

	const refundServices = (services: { serviceId: string; passengerIds: string[] }[]) => {
		request({
			variables: {
				params: {
					orderId,
					services: services.map(service => ({
						id: service.serviceId,
						travellerIds: service.passengerIds
					}))
				}
			}
		});
	};

	return {
		refund: refundServices,
		loading,
		refundedServiceIds,
		refundedWithError
	};
};
